var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarosello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 8.625H15.25C14.3525 8.625 13.625 9.35254 13.625 10.25V31.75C13.625 32.6475 14.3525 33.375 15.25 33.375H24.75C25.6475 33.375 26.375 32.6475 26.375 31.75V10.25C26.375 9.35254 25.6475 8.625 24.75 8.625ZM15.25 7C13.4551 7 12 8.45507 12 10.25V31.75C12 33.5449 13.4551 35 15.25 35H24.75C26.5449 35 28 33.5449 28 31.75V10.25C28 8.45507 26.5449 7 24.75 7H15.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 11.75C31.4142 11.75 31.75 12.0858 31.75 12.5V28.5C31.75 28.9142 31.4142 29.25 31 29.25C30.5858 29.25 30.25 28.9142 30.25 28.5V12.5C30.25 12.0858 30.5858 11.75 31 11.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11.75C9.41421 11.75 9.75 12.0858 9.75 12.5V28.5C9.75 28.9142 9.41421 29.25 9 29.25C8.58579 29.25 8.25 28.9142 8.25 28.5V12.5C8.25 12.0858 8.58579 11.75 9 11.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 14.25C34.4142 14.25 34.75 14.5858 34.75 15V26C34.75 26.4142 34.4142 26.75 34 26.75C33.5858 26.75 33.25 26.4142 33.25 26V15C33.25 14.5858 33.5858 14.25 34 14.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.25C6.41421 14.25 6.75 14.5858 6.75 15V26C6.75 26.4142 6.41421 26.75 6 26.75C5.58579 26.75 5.25 26.4142 5.25 26V15C5.25 14.5858 5.58579 14.25 6 14.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarosello);
export default __webpack_public_path__ + "static/media/carosello.029436aa.svg";
export { ForwardRef as ReactComponent };